import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ReactSwitch from 'react-switch'
import axios from 'axios'
import Swal from 'sweetalert2'
import { apiRequest } from '../../store/allApi'


const Gateway = () => {

//////////URL//////////////
const [paynow1Url, SetPayNow1Url] = useState('')
const [paynow2Url, SetPayNow2Url] = useState('')
const [upi, setUpiId] = useState('')
const [paynow3Url, SetPayNow3Url] = useState('')
const [paynow4Url, SetPayNow4Url] = useState('')
const [paynow5Url, SetPayNow5Url] = useState('')

  const [checkedRozorPayIn, setCheckedRozorPayIn] = useState(true)
  const [checkedRozorPay, setCheckedRozorPay] = useState(true)
  const [checkedHoadaPayIn, setCheckedHoadaPayIn] = useState(true)
  const [checkedHoadaPay, setCheckedHoadaPay] = useState(true)
  const [checkedMyPayIn, setCheckedMyPayIn] = useState(true)
  const [checkedUpiGateway, setUpiGateway] = useState(true)
  const [checkedUpiGateway1, setUpiGateway1] = useState(false)
  const [whatsappDeposit, setwhatsappDeposit] = useState(false)
  const [whatsappRangemin, setWhatsappRangemin] = useState(0)
  const [whatsappRangemax, setWhatsappRangemax] = useState(0)
  const [whatsappdepositurl, setWhatsappdepositurl] = useState('')
  const [checkedV2wallet, setV2wallet] = useState(true)
  const [manualDeposit, setManualDeposit] = useState(true)
  const [checkedMyPay, setCheckedMyPay] = useState(true)
  const [isSubPaisaActive, setisSubPaisaActive] = useState(true)
  const [ispaytmWithdrawal, setIspaytmWithdrawal] = useState(true)
  const [RazorPayout, setRazorpayout] = useState(true)
  const [RazorDeposit, setRazorDeposit] = useState(true)
  const [RazorpayAuto, setRazorpayAuto] = useState(false)
  const [RazorPayKey, setRazorpayKey] = useState()
  const [RazorPaySecretKey, setRazorpaysecretKey] = useState()
  const [AccountName, setAccountName] = useState()
  const [decentroPayout, setdecentropayout] = useState(true)
  const [decentroDeposit, setdecentroDeposit] = useState(true)
  const [pinelabDeposit, setpinelabDeposit] = useState(true)
  const [decentroAuto, setdecentroAuto] = useState(false)
  const [settingId, setSettingId] = useState('')
  const [enable_otp, setEnableOtp] = useState()
  const [isCashFree, setIsCashFree] = useState(false)
  const [isPhonePayActive, setIsPhoneActive] = useState(false)
  const [PayNowOne, setPayNowOne] = useState(true)
  const [PayNowTwo, setPayNowTwo] = useState(true)
  const [PayNowThree, setPayNowThree] = useState(true)
  const [payNowFour, setPayNowFour] = useState(true)
  const [isPayNowFive, setPayNowFive] = useState(true)
  const [upiGatewayMin1, SetUpiGateMin1] = useState(10)
const [upiGatewayMax1, SetUpiGateMax1] = useState(10)
  const [loading, setLoading] = useState(false)


  // images manual payment
const [payOneImage,setPayOneImage] = useState(null)
const [payTwoImage,setPayTwoImage] = useState(null)
const [payThreeImage,setPayThreeImage] = useState(null)
const [payFourImage,setPayFourImage] = useState(null)
const [payFiveImage,setPayFiveImage] = useState(null)

  // console.log(enable_otp)
  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const SiteData = async () => {
    setLoading(true)
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`gatewaysettings/data`, 'GET', null, headers)
      if (res.data) {
        setSettingId(res.data._id ? res.data._id : '')
        setRazorpayout(res.data.RazorPayout)
        setRazorDeposit(res.data.RazorDeposit)
        setRazorpayAuto(res.data.RazorpayAuto)
        setdecentropayout(res.data.decentroPayout)
        setdecentroDeposit(res.data.decentroDeposit)
        setdecentroAuto(res.data.decentroAuto)
        setRazorpayKey(res.data.RazorPayKey)
        setRazorpaysecretKey(res.data.RazorPaySecretKey)
        setAccountName(res.data.AccountName)
        setpinelabDeposit(res.data.pinelabDeposit)
        setEnableOtp(res.data.otp)
        setUpiId(res.data.upi)
        SetUpiGateMin1(res.data.upiGatewayMin1)
        SetUpiGateMax1(res.data.upiGatewayMax1)
        setwhatsappDeposit(res.data.whatsappDeposit)
        setWhatsappRangemin(res.data.whatsappRangemin)
        setWhatsappRangemax(res.data.whatsappRangemax)
        setWhatsappdepositurl(res.data.whatsappdepositurl)
        setIsCashFree(res.data.isCashFreeActive)
        setIsPhoneActive(res.data.isPhonePayActive)
        setCheckedRozorPayIn(res.data.RazorPayout)
        setCheckedRozorPay(res.data.RazorDeposit)
        setCheckedHoadaPayIn(res.data.isHaodaPaypayInActive)
        setCheckedHoadaPay(res.data.isHaodaPayPayOutActive)
        setCheckedMyPayIn(res.data.isMypayInActive)
        setUpiGateway(res.data.isUpiGateway)
        setUpiGateway1(res.data.isUpiGateway1)
        setCheckedMyPay(res.data.isMypayOutActive)
        setManualDeposit(res.data.manualDeposit)
        setisSubPaisaActive(res.data.isSubPaisaActive)
        setIspaytmWithdrawal(res.data.ispaytmWithdrawal)
        setPayNowOne(res.data.isPayNowOne)
        setPayNowTwo(res.data.isPayNowTwo)
        setPayNowThree(res.data.isPayNowThree)
        setPayNowFour(res.data.isPayNowFour)
        setPayNowFive(res.data.isPayNowFive)
        setPayOneImage(res.data.isPayOneImage)
        setPayTwoImage(res.data.isPayTwoImage)
        setPayThreeImage(res.data.isPayThreeImage)
        setPayFourImage(res.data.isPayFourImage)
        setPayFiveImage(res.data.isPayFiveImage)
        SetPayNow1Url(res.data.paynow1Url)
        SetPayNow2Url(res.data.paynow2Url)
        SetPayNow3Url(res.data.paynow3Url)
        SetPayNow4Url(res.data.paynow4Url)
        SetPayNow5Url(res.data.paynow5Url)
      }
    } catch (e) {
      // handle error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    SiteData()
  }, [])

  const handleSubmit1 = async e => {
    e.preventDefault()
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`}
    setLoading(true)
    // Client-side validations
    // ensure numeric fields are numbers
    const upiMin = Number(upiGatewayMin1)
    const upiMax = Number(upiGatewayMax1)
    const waMin = Number(whatsappRangemin)
    const waMax = Number(whatsappRangemax)

    if (!Number.isFinite(upiMin) || !Number.isFinite(upiMax)) {
      Swal.fire('Validation error', 'UPI gateway limits must be valid numbers', 'error')
      return
    }

    if (whatsappDeposit) {
      if (!Number.isFinite(waMin) || !Number.isFinite(waMax)) {
        Swal.fire('Validation error', 'WhatsApp min/max must be valid numbers', 'error')
        return
      }
      if (waMin > waMax) {
        Swal.fire('Validation error', 'WhatsApp min must be less than or equal to max', 'error')
        return
      }
      if (whatsappdepositurl) {
        try {
          new URL(whatsappdepositurl)
        } catch (err) {
          Swal.fire('Validation error', 'WhatsApp URL is not a valid URL', 'error')
          return
        }
        const waPattern = /wa\.me|api\.whatsapp\.com|whatsapp/i
        if (!waPattern.test(whatsappdepositurl)) {
          Swal.fire('Validation error', 'WhatsApp URL should be a WhatsApp link (wa.me or api.whatsapp.com)', 'error')
          return
        }
      }
    }



    try {
      const res = await apiRequest(`gatewaysettings`, "POST", {
        checkedHoadaPayIn,
        checkedHoadaPay,
        checkedMyPayIn,
        checkedUpiGateway1,
        upiGatewayMin1: upiMin,
        upiGatewayMax1: upiMax,
        whatsappDeposit,
        whatsappRangemin: waMin,
        whatsappRangemax: waMax,
        whatsappdepositurl,
        checkedV2wallet,
        manualDeposit,
        checkedMyPay,
        PayNowOne,
        PayNowTwo,
        PayNowThree,
        payNowFour,
        isPayNowFive,
        isSubPaisaActive,
        ispaytmWithdrawal,
        settingId,
        RazorpayAuto,
        decentroPayout,
        decentroDeposit,
        decentroAuto,
        RazorPayKey,
        RazorPaySecretKey,
        AccountName,
        pinelabDeposit,
        otp: enable_otp,
        isCashFreeActive: isCashFree,
        upi,
        paynow1Url,
        paynow2Url,
        paynow3Url,
        paynow4Url,
        paynow5Url
      }, headers)
    if (res.data.status === 'success') {
      await SiteData()
      Swal.fire('Success', 'Settings submitted successfully', 'success')
    } else {
      Swal.fire('Error', 'Settings Not Submitted', 'error')
    }
        } catch (e) {
          // setLoading(false)
            
        }
        finally {
      setLoading(false)
    }
  }

  const handleSaveAll = async () => {
    // call the same submit handler without a real event
    await handleSubmit1({ preventDefault: () => {} })
  }


  const handleChangeRozarpayIn = val => {
    setCheckedRozorPayIn(val)
  }
  const handleChangeRozarpay = val => {
    setCheckedRozorPay(val)
  }
  const handleChangeWhatsapp = val => {
    setwhatsappDeposit(val)
  }
  const handleChangehoadaPayIn = val => {
    setCheckedHoadaPayIn(val)
  }
  const handleChangehoadaPay = val => {
    setCheckedHoadaPay(val)
  }
  const handleChangeMyPayIn = val => {
    setCheckedMyPayIn(val)
  }
  const handleChangeUpi = val => {
    setUpiGateway(val)
  }
  const handleChangeUpi1 = val => {
    setUpiGateway1(val)
  }
  const handleChangeV2V = val => {
    setV2wallet(val)
  }
  const handleChangeMyPay = val => {
    setCheckedMyPay(val)
  }
  const handleManualPay = val => {
    setManualDeposit(val)
  }
  const handleChangePhonepeIn = val => {
    setisSubPaisaActive(val)
  }
  const handleChangePaytm = val => {
    setIspaytmWithdrawal(val)
  }
  const handleChangePayOne = val => {
    setPayNowOne(val)
  }
  const handleChangePayTwo = val => {
    setPayNowTwo(val)
  }
  const handleChangePayThree = val => {
    setPayNowThree(val)
  }
  const handleChangePayFour = val => {
    setPayNowFour(val)
  }
  const handleChangePayFive = val => {
    setPayNowFive(val)
  }

  const uploadImage = (type)=>{
  if(!type){
    return false;
  }
    var formdata = new FormData();
    if(type == "PayNowOne"){
      formdata.append("status", PayNowOne);
      formdata.append("image", payOneImage);
      formdata.append("settingId", settingId);
      formdata.append("paynow1Url", paynow1Url);
    }else if(type == "PayNowTwo"){
      formdata.append("status", PayNowTwo);
      formdata.append("image", payTwoImage);
      formdata.append("settingId", settingId);
      formdata.append("paynow2Url", paynow2Url);
    }else if(type == "PayNowThree"){
      formdata.append("status", PayNowThree);
      formdata.append("image", payThreeImage);
      formdata.append("settingId", settingId);
      formdata.append("paynow3Url", paynow3Url);
    }else if(type == "PayNowFour"){
      formdata.append("status", payNowFour);
      formdata.append("image", payFourImage);
      formdata.append("settingId", settingId);
      formdata.append("paynow4Url", paynow4Url);
    }else{
      formdata.append("status", isPayNowFive);
      formdata.append("image", payFiveImage);
      formdata.append("settingId", settingId);
      formdata.append("paynow5Url", paynow5Url);
    }

formdata.append("image_type", type);


var requestOptions = {
  method: 'POST',
  body: formdata,
  redirect: 'follow'
};

fetch(baseUrl+"gatewaysettings/change_qr", requestOptions)
  .then(response => {
    Swal.fire(
      'Success!',
      'Result Submit Successful',
      'success'
    )
    // window.location.reload(true)
  })
  .then(result => console.log(result))
  .catch(error => console.log('error', error));
  }

  return (
    <>
      <div className='card mt-5' style={{ position: 'relative' }}>
        <div className='card-body  table_bg'>
          {loading && (
            <div style={{position:'absolute',inset:0,background:'rgba(255,255,255,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
              <div className='spinner-border text-primary' role='status'>
                <span className='sr-only'>Loading...</span>
              </div>
            </div>
          )}
          <div className='d-flex align-items-center justify-content-between my-3'>
            <div>
              <h4 className='dashboard_heading mb-1'>Payment Gateway Settings</h4>
              <p className='text-muted mb-0'>Manage payment channels, limits and contact links. Changes apply to the live site after saving.</p>
            </div>
            
          </div>

          {/* <h4 className='my-3 dashboard_small_heading_dark'>Pay In Or Pay Out</h4> */}
           

          {/* <h5 className='dashboard_small_heading_dark my-3'>RazorPay</h5> */}

          <form
            action='gatewaysettings'
            className='form'
            onSubmit={handleSubmit1}
            method='patch'
            enctype='multipart/form-date'
          >

<div className='form-row'>
            
            
          
            {/* <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                     Upi Gateway
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Upi Gateway</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={checkedUpiGateway}
                            onChange={handleChangeUpi}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>

                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>
                          <button type='submit' className='btn btn-dark' disabled={loading}>
                            submit
                          </button>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </div> */}
            <div className='form-group col-md-6'>
                <Card className='mb-4 border-primary'>
                      <Card.Header className='bg-primary text-white'>UPI Gateway</Card.Header>
                      <Card.Body>
                        <Container>
                          <div className='form-group row align-items-center mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>Upi Gateway</label>
                            <div className='col-sm-8'>
                              <ReactSwitch checked={checkedUpiGateway1} onChange={handleChangeUpi1} />
                            </div>
                          </div>

                          <div className='form-group row mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>Upi-Gateway-Min</label>
                            <div className='col-sm-8'>
                              <input
                                type='number'
                                name='upiGatewayMin1'
                                value={upiGatewayMin1}
                                onChange={e => SetUpiGateMin1(Number(e.target.value))}
                                className='form-control'
                                placeholder='Enter Min'
                              />
                            </div>
                          </div>

                          <div className='form-group row mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>Upi-Gateway-Max</label>
                            <div className='col-sm-8'>
                              <input
                                type='number'
                                name='upiGatewayMax1'
                                value={upiGatewayMax1}
                                onChange={e => SetUpiGateMax1(Number(e.target.value))}
                                className='form-control'
                                placeholder='Enter Max'
                              />
                            </div>
                          </div>

                          <div className='form-group row'>
                            <div className='col-sm-12'>
                              <button type='submit' className='btn btn-primary w-100' disabled={loading}>
                                Save UPI Settings
                              </button>
                            </div>
                          </div>
                        </Container>
                      </Card.Body>
                    </Card>
                  </div>
       
          
            
             
          
            </div>

            

            {/* <div className='form-row'>
              <div className='form-group col-md-4'>
                <button type='submit' className='btn btn-dark'>
                  submit
                </button>
              </div>
            </div> */}
          </form>

          <form
            action='gatewaysettings'
            className='form'
            onSubmit={handleSubmit1}
            method='patch'
            enctype='multipart/form-date'
          >

<div className='form-row'>
            
          
            <div className='form-group col-md-6'>
                <Card className='mb-4 border-success'>
                      <Card.Header className='bg-success text-white'>WhatsApp Pay Gateway</Card.Header>
                      <Card.Body>
                        <Container>
                          <div className='form-group row align-items-center mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>WhatsApp Deposit</label>
                            <div className='col-sm-8'>
                              <ReactSwitch checked={whatsappDeposit} onChange={handleChangeWhatsapp} />
                            </div>
                          </div>

                          <div className='form-group row mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>WhatsApp Deposit Min.</label>
                            <div className='col-sm-8'>
                              <input
                                type='number'
                                name='whatsappRangemin'
                                value={whatsappRangemin}
                                onChange={e => setWhatsappRangemin(Number(e.target.value))}
                                className='form-control'
                                placeholder='Min amount'
                              />
                            </div>
                          </div>

                          <div className='form-group row mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>WhatsApp Deposit Max.</label>
                            <div className='col-sm-8'>
                              <input
                                type='number'
                                name='whatsappRangemax'
                                value={whatsappRangemax}
                                onChange={e => setWhatsappRangemax(Number(e.target.value))}
                                className='form-control'
                                placeholder='Max amount'
                              />
                            </div>
                          </div>

                          <div className='form-group row mb-3'>
                            <label className='col-sm-4 col-form-label font-weight-bold text-right'>WhatsApp Deposit URL</label>
                            <div className='col-sm-8'>
                              <div className='input-group'>
                                <div className='input-group-prepend'>
                                  <span className='input-group-text'>🔗</span>
                                </div>
                                <input
                                  type='text'
                                  name='whatsappdepositurl'
                                  value={whatsappdepositurl}
                                  onChange={e => setWhatsappdepositurl(e.target.value)}
                                  className='form-control'
                                  placeholder='Enter WhatsApp URL (e.g., https://wa.me/...)'
                                />
                              </div>
                              <small className='form-text text-muted'>Use a wa.me or api.whatsapp.com link for direct chat.</small>
                            </div>
                          </div>

                          <div className='form-group row'>
                            <div className='col-sm-12'>
                              <button type='submit' className='btn btn-success w-100' disabled={loading}>
                                Save WhatsApp Settings
                              </button>
                            </div>
                          </div>
                        </Container>
                      </Card.Body>
                    </Card>
                  </div>
       
          
            
             
          
            </div>

     
          </form>
     
        
        </div>
      </div>
    </>
  )
}

export default Gateway
